import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function getHeight(windowWidth) {
  if (windowWidth < 340) return 42;
  if (windowWidth < 370) return 46;

  return 50;
}

function Navbar({ className = null, children, ...otherProps }) {
  const classes = classNames('ws-navbar', className);

  return (
    <div className={classes} {...otherProps}>
      {children}
    </div>
  );
}

Navbar.getHeight = getHeight;

Navbar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default Navbar;
